// api/chatApi.js


import {ref} from "vue";
import {store} from "core-js/internals/reflect-metadata";

const APP_ID = ref(process.env.VUE_APP_APP);
const API_KEY = ref(process.env.VUE_APP_API);
const API_URL = 'https://open.bigmodel.cn/api/llm-application/open/v3/application'


export async function* streamChat(messages, signal) {
    const response = await fetch(API_URL + '/invoke', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `${API_KEY.value}`
        },
        body: JSON.stringify({
            app_id: `${APP_ID.value}`,
            conversation_id: store?.conversationId,
            stream: true,
            send_log_event: false,
            // messages列表只含messages中最后一项role为user的项
            messages: messages.filter(m => m.role === 'user').slice(-1),
        }),
        signal, // 支持 abort
    });

    if (!response.ok) throw new Error('Network error');

    const reader = response.body.getReader();
    const decoder = new TextDecoder();

    while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        const chunk = decoder.decode(value, { stream: true });

        // 假设后端使用 SSE 格式：data: {"content": "xxx"}\n\n
        // 或纯文本逐字下发，这里支持两种常见格式
        const lines = chunk.split('\n');
        for (const event of lines) {
            const line = event.trim()
            if (!line.startsWith('data:')) continue

            const dataStr = line.replace(/^data:/, '').trim()
            if (dataStr === '[DONE]') {
                return
            }
            try {
                const json = JSON.parse(dataStr);
                const delta = json.choices?.[0]?.delta
                const conversationId = json.conversation_id
                // 若获取到了会话ID，且store中无ID，保存会话 ID
                if (conversationId && !store.conversationId) {
                    store.conversationId = conversationId
                }
                const content = delta?.content
                if (content?.type === 'text' && content.msg) yield content.msg;
            } catch {
                console.error('Invalid JSON:', line);
            }

        }
    }
}